import React, { Ref } from "react";
import { DownloadIconSvg } from "../../utils/Svgs";
import { PALLETTE } from "../../utils/theme";

const ReportHeader = ({
  title,
  pdfWrapperRef,
}: {
  title:
    | "Growth Report"
    | "Dental Report"
    | "Physical Report"
    | "Eye Report"
    | "ENT Report";
  pdfWrapperRef: Ref<any>;
}) => {
  return (
    <div
      style={{
        position: "sticky",
        top: 0,
        zIndex: 100,
        backgroundColor: PALLETTE.white,
        borderBottom: "1px solid #E5E7EB",
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        padding: "16px 20px",
      }}
    >
      <h2
        style={{
          margin: 0,
          fontSize: "2.5rem",
          fontWeight: "500",
        }}
      >
        {title}
      </h2>
      <div
        role="button"
        style={{ cursor: "pointer" }}
        onClick={() => pdfWrapperRef.current?.generatePDF()}
      >
        <DownloadIconSvg />
      </div>
    </div>
  );
};

export default ReportHeader;
